<div id="imageoneAccount" *ngIf="imageoneAccount">
    <imageone-account [pageDisplay]="pageDisplay" [pageTitle]="pageTitle" [id]="id"></imageone-account>
</div>